// Border variables
export const borders = {
  borderRadiusMd: 4,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ...borders,
};
